<template>
	<div class="automatic-complete-production-list">
		<div class="automatic-complete-production-con">
			<div class="title">
				<i class="x-icon-keys"></i><span
			class="x-tit-con">Intelligent  Automatic Complete Production Line</span>
			</div>

			<div class="list">
				<ul>
					<li><img :src="solution_image_01"/></li>
					<li><img :src="solution_image_02"/></li>
				</ul>

				<div class="un-tt">
					<h3>The Power of Automation + AI:</h3>
					<p>Digitize your work and apply the power of AI:</p>
					<ul class="dd">
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Discover unprecedented opportunities for automation and maximize impact;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								The time it takes to scan millions of data is just a fraction of the time it takes humans to complete the job;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Promote autonomous decision-making and continuous process improvement;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Balance human and machine tasks to create an optimal team of collaborative employees.
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_ime_03.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_ime_04.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
		.un-tt > h3 {
			width: 100%;
			font-family: "Open SB";
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.5rem;
			margin-top: 2.75rem;
			margin-bottom: 1.5rem;
		}

		.dot {
			width: .625rem;
			text-align: left;
		}

		.ll {
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.75rem;
			width: calc(100% - .625rem);
			margin-bottom: 1.375rem;
		}

		.dd > li {
			width: 100%;
		}

		.dd {
			width: 100%;
		}

		.un-tt > p {
			width: 100%;
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.75rem;
			margin-bottom: 2.75rem;
		}

		.un-tt {
			width: 100%;
			height: 21rem;
		}

		.list > ul:nth-child(1) > li > img {
			width: 100%;
			height: 100%;
		}

		.list > ul:nth-child(1) > li:nth-child(1) {
			width: 29.75rem;
		}

		.list > ul:nth-child(1) > li:nth-child(2) {
			width: calc(100% - 29.75rem - 1.5rem);
			margin-left: 1.5rem;
		}

		.list > ul:nth-child(1) > li {
			height: 20rem;
			float: left;
		}

		.list > ul:nth-child(1) {
			width: 100%;
			height: 20rem;
			border: none;
		}

		.automatic-complete-production-con {
			width: 61.5rem;
			border: none;
			margin-left: 0px;
		}

		.automatic-complete-production-list {
			width: 100%;
			height: 47.8125rem;
			border: none;
		}

		.list {
			width: 54.5rem;
			height: 34.5rem;
			border: none;
			margin-left: 7rem;
		}

		.x-tit-con {
			font-size: 1.5rem;
			color: #3B3A38;
			line-height: 3.25rem;
		}

		.title {
			width: calc(100% - 3.25rem);
			text-align: left;
			margin-left: 3.25rem;
			margin-top: 2.75rem;
			margin-bottom: 2.75rem;
		}

		.x-icon-keys {
			display: inline-block;
			content: url("../../../assets/resource/icons/ico_solutions.png");
			width: 2.75rem;
			height: 2.75rem;
			position: relative;
			top: .625rem;
			margin-right: 1rem;
		}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-automatic-complete-production-line.vue